<template>
  <div class="animated fadeIn">
    <b-card class="no-border">
      <b-table striped responsive
        :items="items"
        :fields="fields">
        <template #cell(number)="data">
          <router-link :to="`/shipment_md/shipments/${data.item.id}`">{{data.value}}</router-link>
        </template>
        <template #cell(origin)="data">({{data.value.code}}) {{data.value.name}}</template>
        <template #cell(truck)="data">
          <div>
          <router-link
            :to="`/vehicles/${get(data, 'item.vehicle.id')}`">{{get(data, 'item.vehicle.reg_no')}}</router-link>
            <div class="small text-muted"><i class="fa fa-building-o" aria-hidden="true"></i> {{get(data, 'item.vehicle.company.name')}} </div>
          </div>
        </template>
        <template #cell(driver)="data">
          <router-link
            :to="`/employees/${getDriver(data.item, 'id')}`">{{getDriver(data.item, 'name')}}</router-link>
        </template>
        <template #cell(load_confirmation)="data">
          <div class="small">
            <confirm-checklist :confirmed="getConfirmation(data.item, 'loader_1')" :adt-data="getConfirmation(data.item, 'loader_1')"> Loader</confirm-checklist>
            <confirm-checklist :confirmed="getConfirmation(data.item, 'driver_1')" :adt-data="getConfirmation(data.item, 'driver_1')"> Driver</confirm-checklist>
            <confirm-checklist :confirmed="getConfirmation(data.item, 'w_operator')" :adt-data="getConfirmation(data.item, 'w_operator')"> Weighing</confirm-checklist>
          </div>
        </template>
        <template #cell(created_at)="data">{{formatDateTime(data.value)}}</template>
        <template #cell(leaving_time)="data">{{formatDateTime(get(data.item, 'metadata.time_out'))}}</template>
      </b-table>
      <b-pagination
        class="mt-3"
        align="center"
        size="md"
        :total-rows="totalRows"
        :per-page="perpage"
        v-model="currentPage"
        v-if="totalRows">
      </b-pagination>
      <b-alert v-if="items.length === 0" show>There's no result data.</b-alert>
    </b-card>
  </div>
</template>

<script>
import ConfirmChecklist from '@/components/ConfirmChecklist';
import dateMixin from '@/mixins/date';
import { isEmpty, get } from 'lodash';

export default {
  name: 'find_shipment_result',
  mixins: [dateMixin],
  components: {
    ConfirmChecklist,
  },
  data() {
    return {
      isDataEmpty: true,
      fields: ['number', 'origin', 'truck', 'driver', 'load_confirmation', 'created_at', 'leaving_time'],
      items: [],
      confirmationOptions: [
        { id: 1, value: 'DRIVER', name: 'Driver' },
        { id: 2, value: 'LOADER', name: 'Loader' },
        { id: 3, value: 'W_OPERATOR', name: 'Operator' },
      ],
      perpage: 100,
      currentPage: 1,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'find_shipment_result', name: 'Shipments Result' },
    ]);

    this.pushDataTable(this.results);
    this.initFromUrl();
  },
  computed: {
    results() {
      return this.$store.getters['shipment_md/shipments/dataShipmentsResult'];
    },
    totalRows() {
      return this.$store.getters['shipment_md/shipments/dataShipmentsResultCount'];
    },
  },
  watch: {
    results(data) {
      this.pushDataTable(data);
    },
    currentPage(curPage) {
      this.$router.push({ query: { ...this.$route.query, page: curPage } });
      setTimeout(() => {
        this.loadData();
      }, 1e2);
    },
  },
  methods: {
    initFromUrl() {
      const { query } = this.$route;

      if (query.page !== undefined) {
        this.currentPage = query.page;
      }

      if (query.query !== undefined && isEmpty(this.items)) {
        this.loadData();
      }
    },
    loadData() {
      const { query } = this.$route;
      const queryType = query.type;
      const curPage = query.page;

      const limit = this.perpage;
      const postData = {
        limit,
        offset: curPage > 1 ? (curPage * limit) - limit : 0,
      };

      postData[queryType] = query.query;

      if (queryType === 'customer_name') {
        postData.start_date = query.start_date;
        postData.end_date = query.end_date;
      }

      return this.$store.dispatch('shipment_md/shipments/FIND_SHIPMENTS_BY_RELATED_ORDER', postData);
    },
    get(obj, key) {
      return get(obj, key);
    },
    getConfirmation(data, key) {
      return data.confirmations.find(c => c.key === key);
    },
    getDriver(data, key) {
      const driverVehicle = get(data, 'vehicle.driver');
      const driver = get(data, 'driver');
      let value = '-';

      if (!isEmpty(driverVehicle) || !isEmpty(driver)) {
        value = isEmpty(driver) ? driverVehicle[key] : driver[key];
      }

      return value;
    },
    pushDataTable(data) {
      this.items.slice(0);
      this.items = data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/find_shipment_result/Index.vue